import { useParams } from "react-router-dom";

import { useReadBudgetById } from "../../../../../../hooks/react-query/use-read-budget-by-id";
import { useReadBudgetDetailedLevelById } from "../../../../../../hooks/react-query/use-read-budget-detailed-levels";
import { useReadBudgetDocument } from "../../../../../../hooks/react-query/use-read-budget-documents";
import { defaultReadBudgetData } from "../../../../../../services/budget/read-budgets";
import DocumentContent from "./documentation-content";

function DocumentationTab() {
    const { budgetId } = useParams();

    const id = budgetId ?? "";
    const levelsParams = {
        length: 500,
        page: 1,
    };

    const { data: dataBudgetById, isLoading } = useReadBudgetById({
        budgetId: id,
    });

    const { data: dataLevels, isLoading: isLoadingLevels } =
        useReadBudgetDetailedLevelById({
            budgetId: id,
            params: levelsParams,
        });

    const {
        data: dataDocuments,
        isLoading: isLoadingDocument,
        refetch,
    } = useReadBudgetDocument({
        budgetId: id,
    });
    if (isLoading || isLoadingLevels || isLoadingDocument)
        return <>loading...</>;
    const budgetData = dataBudgetById ?? defaultReadBudgetData;
    const documentsData = dataDocuments ?? [];
    const levelData = dataLevels?.data ?? [];

    return (
        <DocumentContent
            budgetData={budgetData}
            documentsData={documentsData}
            levelData={levelData}
            refetchDocuments={refetch}
        />
    );
}

export default DocumentationTab;
